<div class="missed-call-overlay" *ngIf="missedCallData">
  <div class="missed-call-card">
    <button class="close-btn" (click)="dismiss()" aria-label="Close">
      <i class="fas fa-times"></i>
    </button>

    <div class="alert-icon">
      <i class="fas fa-exclamation"></i>
    </div>

    <h2 class="title">Missed Doctor Call</h2>

    <p class="message">
      You missed a {{ missedCallData.callType }} call from
      <strong>Dr. {{ missedCallData.doctorName || "your doctor" }}</strong
      >. Please reconnect as soon as possible to continue the consultation.
    </p>

    <div class="booking-badge" *ngIf="missedCallData.bookingId">
      <i class="fas fa-id-card"></i>
      Booking ID: <strong>#{{ missedCallData.bookingId }}</strong>
    </div>

    <button class="btn-callback" (click)="callBack()">Okay</button>
  </div>
</div>
